
<template>
  <Modal :id="'cpm-add-contact-modal'" @cancelled="onCancel">
    <template slot="header">{{$t('add_backorder')}}</template>

    <template slot="body">
      <!-- <span>c{{ company }} p{{ person }}</span> -->

      <div class="fform-group">
      

  
          <Dropdown
              :options="accountsTV"
              class="group-input m2"
              :key="'group_dropdown_company'"
              :placeholder="$t('account')"
              v-on:selectedChange="(e) => onFormatChange(e)"
              :selected="accountsTV.find(e=>e.value==accountId)"
              box            
              :listHeight="250"
          ></Dropdown>
      
        <TextField
          class="m1"
          :id="'qty'"
          v-bind="textFieldConfig"
          v-model="qty"
          isModel
          :placeholder="$t('Qty')"
          @valuechanged="onValueChange"
        >
        </TextField>
     
        
      </div>

    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{$t('cancel')}}
      </button>
      <button
        class="dt-button v1 with-ico"
        :class="{ disabled: !isFormValid }"
        :disabled="!isFormValid"
        
        @click.stop="addNewProduct"
      >
        {{$t('ok')}}
      </button>
    </template>
  </Modal>
</template>

<script>
import { createValidator } from "@plugins/text-field";



import Modal from "@/dt-plugins/modal/modal";
import { createTV, tv } from "../../../../models/text-value.model";
import { releaseService } from '../../services/releases/releases.services';
import { ProductsService } from '../../services/products.service';
import { format, formatDistance, formatRelative, subDays } from 'date-fns';
export default {
  components: {
    Modal
  
  },
  props: {},
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        
      },
      textFieldConfig2: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        immediateValidation: false,
      },

      loading: true,
      accounts:[],
      relatedProducts:[],
      accountId:0,
      formatId:16,
      qty:0,
    
      
      validationResult: {},
      selectedProductMedia:{}

      
    };
  },
  mounted:async function () {
      const resData=await ProductsService.productAccountBackorderForm(this.external_id);
      console.log("RES DATA",resData);
      this.accounts=resData.data.accounts;
      //this.selectedProductMedia=resData.data.product_media||{}

  },
  computed: {
    external_id: function() {
      return this.$route.query.external_id;
    },
   
    accountsTV:function(){
      return createTV(this.accounts, 'account_name','account_id');
    },

    isFormValid: function() {
      return Object.values(this.validationResult).every(e => e.valid);
    }

 
  },
  methods: {
 
    onValueChange:function(){

    },

    onCancel: function () {
      this.$emit("cancelled", true);
    },

    addNewProduct: function (e) {
      const payload={ 
                      external_id:this.external_id,
                      account_id:this.accountId,
                      qty:this.qty
                    };
      
      this.$emit("create",payload)

    },
  
    onFormatChange: function (value) {
      console.log("VALUE",value)
      this.accountId=value.value
    },

    //MARK: Methods
  },
};


</script>

<style lang="scss">
.cpm-add-contact-modal {
  .form-group {
    display: flex;
    flex-direction: column;

    // .dt-input-box--container {
    //   flex: 1;
    //   margin: 5px 0px;
    //   margin-left: 0px;
    // }

    .group-input {
      // margin-top: 25px;
      // margin-bottom: 10px;
      // margin-right: 5px;

      min-height: 42px;
    }
  }

  .person-controls,
  .company-controls {
    height: 249px;
  }

  .contact-type-selection {
    display: flex;
    flex-direction: column;
    padding: 0px;
    margin-bottom: 10px;
    .contact-type {
      flex: 1;
      display: flex;
      margin: 4px 0px;

      input {
        margin: auto 0;
      }
      label {
        margin-left: 10px;
        cursor: pointer;
      }
    }
  }

  .dt-modal--options {
    display: flex;
    justify-content: flex-end;
    button {
      flex: 1;
      &:first-child {
        margin-right: 10px;
      }
      &:last-child {
        margin-left: 10px;
      }
    }
  }
}
</style>
